export default __webpack_public_path__ + "static/media/IMG_4157.3433fe03.jpg";